import React, { Component } from 'react'
import { Wrap, Label, InputContainer, StyledTextArea } from './styles'

class Textarea extends Component {
  render() {
    const { label, type, value, handleChange, placeholder, name, dataKey, valid } = this.props

    return (
      <Wrap>
        {label ? <Label>{label}</Label> : null}

        <InputContainer>
          <StyledTextArea
            type={type}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            name={name}
            valid={valid}
            data-key={dataKey}
          />
        </InputContainer>
      </Wrap>
    )
  }
}

export default Textarea



// WEBPACK FOOTER //
// ./src/components/Input/Textarea.js